import type { DialogOption } from '../../../shared/NPCData';

interface DialogueActions {
  close(): void;
  completeTutorial(): void;
  openBank(): void;
  learn(abilityId: string): void;
  send(action: string, data: any): void;
}

/** The current dialog contributes only its NPC identity and typed action.
 * Existing bank/tutorial/trainer callbacks retain their previous ordering. */
export function dispatchNpcDialogueAction(npcId: string, option: DialogOption, actions: DialogueActions): void {
  if (option.ferryAction === 'board_ferry') {
    actions.close();
    actions.send('npcFerryTravel', { npcId, actionId: 'board_ferry' });
  } else if (option.action === 'complete_tutorial') {
    actions.completeTutorial(); actions.close();
  } else if (option.action === 'bank') {
    actions.close(); actions.openBank();
  } else if (option.action?.startsWith('learnAbility:')) {
    actions.learn(option.action.slice('learnAbility:'.length));
  } else if (option.action === 'close') {
    actions.close();
  } else if (option.action?.startsWith('complete_quest:')) {
    const questId = option.action.slice('complete_quest:'.length);
    actions.send('completeQuest', { questId, npcId });
  } else if (option.action?.startsWith('accept_quest:')) {
    const questId = option.action.slice('accept_quest:'.length);
    actions.send('acceptQuest', { questId, npcId });
  }
}
